"use client";

import { ComponentProps } from "react";
import { Link } from '@chakra-ui/next-js';
import { useFilters } from "~/hooks/useFilters";

export function LinkWithFilterReset(props: ComponentProps<typeof Link>) {
  const { resetFilters } = useFilters();
  return (
    <Link
      {...props}
      onClick={() => resetFilters()}
    />
  );
}

